import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { PageHead, Card, Pill, FilterBar, TextInput, Loading, Err, tableStyles, EmptyState } from "./_shared";

export default function AuditLogs() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  const [action, setAction] = useState("");

  useEffect(() => {
    const url = new URLSearchParams();
    if (action) url.set("action", action);
    api.get("/api/admin/audit-logs" + (url.toString() ? "?" + url.toString() : ""))
      .then((d) => setItems(d.items)).catch((e) => setErr(e.message));
  }, [action]);

  if (err) return <Err msg={err} />;

  return (
    <div data-testid="admin-audit-logs">
      <PageHead title="Audit logs" sub={`${items?.length ?? 0} entries · last 300`} />
      <FilterBar>
        <TextInput value={action} onChange={setAction} placeholder="Filter by action (e.g. credits.grant)…" data-testid="audit-filter-action" />
      </FilterBar>

      {!items ? <Loading /> : items.length === 0 ? (
        <EmptyState title="No audit entries match" />
      ) : (
        <Card pad={0} style={{ overflow: "hidden" }}>
          <table style={tableStyles.table}>
            <thead>
              <tr>
                <th style={tableStyles.th}>When</th>
                <th style={tableStyles.th}>Action</th>
                <th style={tableStyles.th}>Actor</th>
                <th style={tableStyles.th}>Workspace</th>
                <th style={tableStyles.th}>Resource</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} style={{ borderTop: "1px solid var(--pl-border)" }}>
                  <td style={{ ...tableStyles.td, fontSize: 11 }}>{(a.created_at || "").slice(0, 19)}</td>
                  <td style={tableStyles.td}><Pill tone="aqua">{a.action}</Pill></td>
                  <td style={{ ...tableStyles.td, fontFamily: "JetBrains Mono, monospace", fontSize: 11 }}>{(a.actor_user_id || "—").slice(0, 16)}</td>
                  <td style={{ ...tableStyles.td, fontFamily: "JetBrains Mono, monospace", fontSize: 11 }}>{(a.workspace_id || "—").slice(0, 16)}</td>
                  <td style={tableStyles.td}>{a.resource_type}{a.resource_id ? ` · ${(a.resource_id + "").slice(0, 18)}` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
